import { render, staticRenderFns } from "./AddDemo.vue?vue&type=template&id=27c459b1&scoped=true"
import script from "./AddDemo.vue?vue&type=script&lang=js"
export * from "./AddDemo.vue?vue&type=script&lang=js"
import style0 from "./AddDemo.vue?vue&type=style&index=0&id=27c459b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c459b1",
  null
  
)

export default component.exports